import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_NUEVA_ASISTENCIA;
async function setAssistance(day, obs) {
  const bodyParams = {
    fecha_asistencia: day,
    observaciones: obs,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { setAssistance };
